@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

.channelTopParent {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include small() {
    margin-top: 15px;
  }
}

@mixin channelTopText() {
  font-family: "Inter";
  font-style: normal;
  text-align: center;
  font-feature-settings: "liga" off;
  color: #39393a;
}

.channelTopTitle {
  @include channelTopText();
  display: flex;

  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 24px;
}

.channelTopSubTitle {
  @include channelTopText();
  margin-bottom: 32px;

  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.channelSrcMark {
  margin-bottom: 32px;
}

.channelBottomParent {
  margin-top: 24px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.closeButtonContainer {
  display: flex;
  justify-content: flex-end;
  padding: 21px 21px 0 0;
}

.channelButtonDiv {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;

  position: -webkit-sticky; /* Safari */
  position: sticky;
  bottom: 0px;
  background-color: white;
  @include medium() {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.channelInfoText {
  position: relative;
  max-width: 565px;
  margin-bottom: 32px;
  padding-left: 72px;
  padding-right: 72px;

  @include medium() {
    max-width: 100%;
    padding-left: 24px;
    padding-right: 24px;
  }
}

@mixin button() {
  width: 100%;
  max-width: 376px;
  height: 48px;
  display: flex;
  margin-bottom: 40px;

  justify-content: center;
  align-items: center;

  cursor: pointer;
  border-radius: 24px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.otpChannel {
  @include windowSizes();

  border: 1px solid #c5c5ca;
  border-radius: 20px;
  background-color: white;

  overflow: auto;

  &ContinueButton {
    @include button();
    background: #16182b;
    color: #ffffff;
  }

  &ItemsRadioList {
    padding-left: 72px;
    padding-right: 38px;
    margin-bottom: 32px;
    margin-right: 34px;
    max-height: 195px;

    @include medium() {
      padding-left: 24px;
      padding-right: 14px;
      margin-right: 10px;
    }
  }
}
